export default __webpack_public_path__ + "static/media/spring.20c30e27.png";